import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { HandleError } from '../../core/models/handle-error';
import { AnalyticsService } from '../../core/services/analytics/analytics.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { ToolsAndEquipmentManualsService } from '../tool-report/tools-and-equipment-manuals.service';
import { UserProfileService } from '../user-profile/user-profile.service';
import { NgIf, NgClass, NgStyle, NgFor, LowerCasePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SearchFilterPipe } from '../../shared/pipes/search-filter.pipe';

@Component({
    selector: 'app-equipment-manuals',
    templateUrl: './equipment-manuals.component.html',
    styleUrls: ['./equipment-manuals.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgClass,
        NgStyle,
        FormsModule,
        NgFor,
        LowerCasePipe,
        SearchFilterPipe,
    ],
})
export class EquipmentManualsComponent implements OnInit, OnDestroy {

  public newDocsCount: number;
  public serviceError = 'Loading data. Please wait...';

  public screenWidth: number;
  private subscriptions: ISubscription[];
  public equipmentManuals: any;
  public search4Manuals;
  APP_SETTINGS: any;
  public isShowAll = false;
  public isShowNew = true;
  public isShowHistory = false;
  errorMessage = '';

  private username;

  constructor(
    private utilityService: UtilityService,
    private spinnerService: SpinnerService,
    private toolsAndEquipmentManualsService: ToolsAndEquipmentManualsService,
    private authService: AuthService,
    private analyticsService: AnalyticsService,
    private userProfileService: UserProfileService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.username = this.authService.getUserName();
    this.subscriptions = [];
    APP_SETTINGS.currentPage = 'equip-manuals';
    this.APP_SETTINGS = APP_SETTINGS;
    if (APP_SETTINGS.equipManual == 'all') { this.showAll(); }
    if (APP_SETTINGS.equipManual == 'new') { this.showNew(); }
    if (APP_SETTINGS.equipManual == 'history') { this.showHistory(); }
    this.equipmentManuals = [];
  }
  showAll() {
    this.isShowAll = true;
    this.isShowNew = false;
    this.isShowHistory = false;
    this.errorMessage = '';
    APP_SETTINGS.equipManual = 'all';
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.toolsAndEquipmentManualsService.getAllEquipmentManuals().subscribe(data => {
      this.equipmentManuals = data['content'];
      this.newDocsCount = data['newSize'];
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  showNew() {
    this.isShowAll = false;
    this.isShowNew = true;
    this.isShowHistory = false;
    this.errorMessage = '';
    APP_SETTINGS.equipManual = 'new';
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.toolsAndEquipmentManualsService.getNewEquipmentManuals().subscribe(data => {
      this.equipmentManuals = data;
      if (this.equipmentManuals.length === 0) {
        this.errorMessage = 'No New Equipment Manuals Found';
      }
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  showHistory() {
    this.isShowAll = false;
    this.isShowNew = false;
    this.isShowHistory = true;
    this.errorMessage = '';
    APP_SETTINGS.equipManual = 'history';
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.toolsAndEquipmentManualsService.getUserEquipmentManualHistory(this.username).subscribe(data => {
      this.equipmentManuals = data;
      if (this.equipmentManuals.length === 0) {
        this.errorMessage = 'No History Found';
      }
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }

  saveToHistory(isSaved, docId, documentTitle) {
    if (!isSaved) {
      this.subscriptions.push(this.toolsAndEquipmentManualsService.addEquipmentManualToHistory(this.username, docId).subscribe(value => {
      }));
    }
    //Analytics Call
    if (APP_SETTINGS.isAdmin === 'true') {
      this.analyticsService.trackClicksbyAdminUser('Equipment Manuals', documentTitle, this.username);
    }

    else {
      this.analyticsService.trackClicksByDocumentsContentTypeLineMake('Equipment Manuals', documentTitle);
    }
    if (APP_SETTINGS.isExternal === 'true') {
      this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
        this.analyticsService.trackClicksByExternalContentType('Equipment Manuals', documentTitle, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
      });
    }
    if (APP_SETTINGS.isDealer === 'true') {
      this.analyticsService.trackDealerContentTypeLocation('Equipment Manuals', documentTitle, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
        APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
    }
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

}
